export const getSortImage = (key: string, filterSortKey?: string, filterSortDir?: string) => {
	let currSortDirection = '⇅';

	if (filterSortKey === key) {
		if (filterSortDir === 'asc') {
			currSortDirection = '↓';
		} else if (filterSortDir === 'desc') {
			currSortDirection = '↑';
		}
	}

	return currSortDirection;
};
